import Checkmark32 from '@carbon/icons-react/es/checkmark/32';
import WarningFilled32 from '@carbon/icons-react/es/warning--filled/32';
import { Result } from 'antd';
import styled from 'styled-components';
import { Loading } from 'components/atoms/loading';
import { ProductiveHeading03, ProductiveHeading05 } from 'components/styles';

export const FullPageResult = styled(Result)`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 10vh;
  width: 50%;
  margin: auto;
  .ant-result-title {
    margin-top: var(--spacing-06);
    ${ProductiveHeading03};
  }
  .ant-result-subtitle {
    margin-top: var(--spacing-04);
    ${ProductiveHeading05};
  }
  .ant-result-extra {
    margin-top: var(--spacing-09);
  }
`;

export const ErrorIcon = styled(WarningFilled32)`
  color: var(--coolest-gray-40);
  width: 160px !important;
  height: 160px !important;
`;

export const SuccessIcon = styled(Checkmark32)`
  color: var(--coolest-gray-40);
  width: 160px !important;
  height: 160px !important;
`;

export const LoadingIcon = styled(Loading)`
  padding-top: 20vh;
`;
